export default "__VITE_ASSET__DztNDWbw__"